/** 07_DOMAIN_MODEL §3.3 실측 + OD-018 로 GACHA_STORE 승격. */
export const CATEGORY_CODES = [
  "POPUP_STORE", "COLLAB_CAFE", "GOODS_STORE", "GACHA_STORE",
  "HOLY_PLACE", "FAN_EVENT", "EXHIBITION", "CONCERT", "CAFE", "DEFAULT",
] as const;
export type CategoryCode = (typeof CATEGORY_CODES)[number];

export interface Category { id?: string; code: CategoryCode | string; name: string }

/**
 * Legacy 별칭. 09_API_CONTRACT §7 Mapping Contract.
 * 표시 시점에만 접는다. 전송할 때는 사용자가 고른 코드를 그대로 보낸다.
 */
export const CATEGORY_ALIASES: Readonly<Record<string, CategoryCode>> = {
  POPUP: "POPUP_STORE", POPUP_EVENT: "POPUP_STORE", POP_UP: "POPUP_STORE",
  PILGRIMAGE: "HOLY_PLACE", HOLY: "HOLY_PLACE",
  EVENT: "FAN_EVENT",
};

export function normalizeCategoryCode(code?: string | null): CategoryCode {
  const raw = (code ?? "").trim().toUpperCase().replace(/[\s-]+/g, "_");
  if ((CATEGORY_CODES as readonly string[]).includes(raw)) return raw as CategoryCode;
  return CATEGORY_ALIASES[raw] ?? "DEFAULT";
}
